import { Navigate, useLocation, useOutlet } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useStripeCheckoutReturn } from '../hooks/useStripeCheckoutReturn'
import GlobalSidebar from '../components/GlobalSidebar'
import { FreePlanBanner } from '../components/FreePlanBanner'


export const ProtectedLayout = () => {
  const outlet = useOutlet()
  const location = useLocation()
  const { userData } = useAuth()
  useStripeCheckoutReturn()
  const isProductionStage =
    String(import.meta.env.VITE_STAGE || import.meta.env.STAGE || '').toLowerCase() ===
    'production'
  const isSuperAdmin = Boolean(
    userData?.userAccount?.[0]?.superAdmin ||
    userData?.userAccount?.some((account) => account?.superAdmin),
  )

  const isAiManagerPage =
    location.pathname.toLowerCase() === '/aimanager' ||
    location.pathname.toLowerCase() === '/promptmanagerlist' ||
    location.pathname.toLowerCase() === '/promptmanagercreate' ||
    location.pathname.toLowerCase().startsWith('/promptmanageredit/')


  if (!userData) {
    return <Navigate to={`/SignIn${location.search || ''}`} replace />
  }

  if (isAiManagerPage) {
    if (isProductionStage || !isSuperAdmin) {
      return <Navigate to={`/ChatSocket${location.search || ''}`} replace />
    }
    return (
      <div
        style={{
          display: 'flex',
          flex: 1,
          width: '100%',
          minWidth: 0,
          height: '100%',
          minHeight: '100dvh',
          boxSizing: 'border-box',
          background:
            'radial-gradient(circle at top left, rgba(227, 161, 255, 0.18) 0%, rgba(255, 255, 255, 0.95) 28%, #ffffff 62%)',
        }}
      >
        <GlobalSidebar />
        <div
          style={{
            display: 'flex',
            flex: 1,
            minWidth: 0,
            height: '100%',
            minHeight: '100dvh',
            boxSizing: 'border-box',
          }}
        >
          {outlet}
        </div>
      </div>
    )
  }


  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        boxSizing: 'border-box',
        padding: 0,
        margin: 0,
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        overflow: 'visible',
        height: '100%',
        minHeight: '100dvh',
        background:
          'radial-gradient(circle at top left, rgba(227, 161, 255, 0.18) 0%, rgba(255, 255, 255, 0.95) 28%, #ffffff 62%)',
      }}
    >
      <GlobalSidebar />

      <div
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          padding: 0,
          margin: 0,
          boxSizing: 'border-box',
          minWidth: 0,
          minHeight: '100dvh',
        }}
      >
        <FreePlanBanner />

        <style>
          {`
              ::-webkit-scrollbar {
                  width: 6px;
              }

              ::-webkit-scrollbar-thumb {
                  background-color: #bdbcbc; 
                  border-radius: 6px;

              }
          `}
        </style>

        <div
          style={{
            display: 'flex',
            boxSizing: 'border-box',
            flexDirection: 'column',
            flex: 1,
            padding: 0,
            margin: 0,
            overflowX: 'hidden',
            overflowY: 'auto',
            minHeight: 0,
            minWidth: 0,
            marginRight: 2,
          }}
        >
          {outlet}
        </div>
      </div>
    </div>
  )
}
